import React, { useState, useEffect, useMemo } from "react";
import MakeRequest from "../Helpers/MakeRequest";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import ReactQuill from "react-quill";
import QuillExports from '../Helpers/QuillHelpers';
import axios from 'axios';
import apiUrl from "../Helpers/APIWrapper";
import toBlob from "../Helpers/FileBlobs";

const EditExpertise = ({ type }) => {
        const { l } = useOutletContext();
        const { quillModules, quillFormats } = QuillExports();
    
        const [content, setContent] = useState({
            content: { sv: "", en: "" }, image: null
        });
    
        const [saveDisabled, setSaveDisabled] = useState(true);
        const [saving, setSaving] = useState(false);
    
        useEffect(() => {
            const fetchAbout = async () => {
                try {
                    const response = await MakeRequest(
                        null,
                        `content/pageContent?page=expertise&type=${type}`,
                        "get"
                    );
                    console.log("response.data", response.data)
                    if (response.data) {
                        setContent(response.data[0]);
                    }
                } catch (error) {
                    console.error("Failed to fetch expertise page:", error);
                }
            };
            fetchAbout();
        }, []);
    
        const handleSaveChanges = async () => {
            try {
                setSaving(true);
    
                let imagePath = null;
    
                if (content.image && content.image.startsWith("data:")) {
                    const blob = toBlob(content.image); // if toBlob is sync, drop await
    
                    // derive a sane filename from the MIME type
                    const ext = (blob.type && blob.type.split('/')[1]) || 'bin';
                    const filename = `image.${ext}`;
    
                    const formData = new FormData();
                    formData.append("image", blob, filename); // <-- not the data URL!
    
                    // IMPORTANT: don't set Content-Type yourself; let axios do it
                    const response = await axios.post(
                        `${apiUrl}/content/imageUpload`,
                        formData,
                        { withCredentials: true }
                    );
    
                    if (response.status >= 400) throw new Error("Image upload failed");
    
                    if (response.data?.file) {
                        imagePath = `${apiUrl.replace('api', `files/${response.data.file.filename}`)}`;
                    }
                } else if (content.image) {
                    imagePath = content.image; // already a URL, no need to upload
                }
    
                const updatedAbout = { ...content, image: imagePath };
    
                const response = await MakeRequest(
                    updatedAbout,
                    `content/pageContent?page=expertise&type=${type}`,
                    "post"
                );
    
                if (response.status === 200) {
                    alert(l("Information sparades.", "Information saved successfully"));
                    setSaveDisabled(true);
                } else {
                    alert(l("Misslyckades att spara information.", "Failed to save information"));
                }
            } catch (e) {
                console.error(e);
                alert(l("Misslyckades att spara information.", "Failed to save information"));
            } finally {
                setSaving(false);
            }
        };
    
        const handleContentChange = (lang, value) => {
            setSaveDisabled(false);
            setContent((prev) => ({
                ...prev,
                content: { ...prev.content, [lang]: value },
            }));
        };
    
        const handleImageChange = e => {
            setSaveDisabled(false);
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setContent(prev => ({ ...prev, image: reader.result }));
                };
                reader.readAsDataURL(file);
            };
        };

        console.log("HEJEJ")
    
        return (
            <>
                <Form>
                    <Row>
                        <Col xxl={4} xl={4} lg={5}>
                            <Form.Group controlId={`formFile`} className="mb-4">
                                <Form.Label style={{ fontWeight: "bold" }}>
                                    {l("Bild", "Image")}
                                </Form.Label>
                                {content.image && (
                                    <img
                                        src={content.image}
                                        alt="Example"
                                        style={{ width: "200px", display: "block", marginBottom: "8px" }}
                                    />
                                )}
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleImageChange(e)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
    
                    <Form.Group className="mb-4">
                        <Form.Label style={{ fontWeight: "bold" }}>
                            {l("Innehåll (Svenska)", "Content (Swedish)")}
                        </Form.Label>
                        <ReactQuill
                            theme="snow"
                            value={content?.content?.sv || ""}
                            onChange={(val) => handleContentChange("sv", val)}
                            modules={quillModules}
                            formats={quillFormats}
                            placeholder={l("Skriv innehållet här…", "Write content here…")}
                            style={{ backgroundColor: "white" }}
                        />
                    </Form.Group>
    
                    <Form.Group className="mb-4">
                        <Form.Label style={{ fontWeight: "bold" }}>
                            {l("Innehåll (Engelska)", "Content (English)")}
                        </Form.Label>
                        <ReactQuill
                            theme="snow"
                            value={content?.content?.en || ""}
                            onChange={(val) => handleContentChange("en", val)}
                            modules={quillModules}
                            formats={quillFormats}
                            placeholder={l("Skriv innehållet här…", "Write content here…")}
                            style={{ backgroundColor: "white" }}
                        />
                    </Form.Group>
                </Form>
    
                <Row className="d-flex justify-content-center">
                    <Button
                        style={{ width: "200px" }}
                        onClick={handleSaveChanges}
                        disabled={saveDisabled || saving}
                    >
                        {saving
                            ? l("Sparar…", "Saving…")
                            : l("Spara ändringar", "Save Changes")}
                    </Button>
                </Row>
            </>
        );
};

export default EditExpertise;